import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';

import { Divider } from 'legacyComponents/styled/lib';
import { analytics } from 'core/analytics';
import { Link } from 'core/routing';
import { html } from 'libs/editor/serializers/html';
import { EditorStore } from 'libs/editor/store';
import { Editor } from 'libs/editor';
import { EditorField } from 'libs/forms/views/fieldTypes/editor';
import FormActionButton from 'libs/forms/views/formActionButton';
import { Date } from 'apps/components/date';

import { modalStore } from 'apps/modals/app';
import { ConfirmAction } from 'apps/modals/confirmAction/index';
import { clientStore } from 'apps/client/app';
import Like from 'apps/content/views/like';

import {
  CommentActions,
  Wrapper,
  Main,
  Head,
  Commentor,
  Time,
  Edit,
  BodyWrapper,
  DeleteBtn,
} from 'apps/comments/views/comment.styles';

import { Avatar } from 'components';

@withNamespaces()
@observer
export class Comment extends React.Component {
  render() {
    const { app, first, contentType, thread } = this.props;
    const contentString = contentType
      ? contentType.toLowerCase()
      : 'unknown-content';
    const {
      editing,
      creatorProfile,
      body,
      dateCreated,
      lastUpdated,
      id,
      canUpdate,
      canDelete,
      Delete,
    } = app;
    const signedIn = clientStore.signedInProfile;
    if (editing) {
      return (
        <Wrapper>
          <Avatar
            name={signedIn.imageFallbackChar}
            src={signedIn.avatar}
            size='large'
          />
          <Main thread={thread}>
            <Commentor>
              {id !== '' ? (
                <Trans>Edit your comment</Trans>
              ) : first ? (
                <Trans>Start the discussion</Trans>
              ) : (
                <Trans>Join the discussion</Trans>
              )}
            </Commentor>

            <EditorField
              fieldStore={app.form.fieldStores.get('body')}
              editComponent={BodyWrapper}
              paragraphSpacing='paragraphSpacing12'
              noValidationIcon
            />
            {id === '' ? (
              <CommentActions thread={thread}>
                <FormActionButton
                  formStore={app.form}
                  buttonText='Comment'
                  buttonTextPosting='Commenting...'
                  buttonHandler={() => {
                    analytics.sendEvent(`commented-${contentString}`);
                    app.Submit();
                  }}
                  size='small'
                />
              </CommentActions>
            ) : (
              <CommentActions thread={thread}>
                <FormActionButton
                  formStore={app.form}
                  buttonText='Cancel'
                  buttonHandler={() => app.Cancel()}
                  size='small'
                  variant='destructive'
                />
                <FormActionButton
                  formStore={app.form}
                  buttonText='Save'
                  buttonTextPosting='Saving...'
                  buttonHandler={() => app.Update()}
                  size='small'
                />
              </CommentActions>
            )}
          </Main>
        </Wrapper>
      );
    }
    const store = new EditorStore({
      initialValue: html.deserialize(body || '<p></p>'),
      formatting: 'markdown',
    });
    // FIXME - look into comment lifecycle.
    // There's a bug related to deleting comments that have been just posted
    // as they apparently "point" or "use" commentFormApp.
    // Maybe it's caused by an old reference being passed to this Comment component
    if (!creatorProfile) return null;
    return (
      <Wrapper>
        <Link
          name='profile'
          params={{ profile: creatorProfile.user.username }}
          content={creatorProfile.content}
        >
          {/* <CommentorAvatar */}
          {/*  thread={thread} */}
          {/*  src={imageSrc( */}
          {/*    creatorProfile.avatar, */}
          {/*    creatorProfile.imageFallbackPath, */}
          {/*    mainConf.imgSizes.profile.small, */}
          {/*  )} */}
          {/* /> */}
          <Avatar
            name={creatorProfile.imageFallbackChar}
            src={creatorProfile.avatar}
            size='large'
          />
        </Link>
        <Main thread={thread} viewMode={true}>
          <Head>
            <Link
              name='profile'
              params={{ profile: creatorProfile.user.username }}
              content={creatorProfile.content}
            >
              <Commentor underline>{creatorProfile.user.username}</Commentor>
            </Link>
            <Time>
              {' '}
              <Trans>commented</Trans> <Date value={dateCreated} />
            </Time>{' '}
            {canUpdate ? (
              <span>
                <Time>
                  {dateCreated !== lastUpdated
                    ? ['(', <Trans key='text'>Edited</Trans>, ')']
                    : ''}
                  &nbsp;|&nbsp;
                </Time>
                <Edit onClick={() => app.Edit()}>
                  <Trans>Edit</Trans>
                </Edit>
              </span>
            ) : (
              ''
            )}
            {canDelete ? (
              <span>
                <Time>&nbsp;|&nbsp;</Time>
                <DeleteBtn
                  onClick={() =>
                    modalStore.SetModalComponent(ConfirmAction, {
                      callBack: Delete,
                      title: 'delete this Comment?',
                      undo: false,
                    })
                  }
                >
                  <Trans>Delete</Trans>
                </DeleteBtn>
              </span>
            ) : (
              ''
            )}
          </Head>
          <BodyWrapper viewMode thread={thread}>
            <Editor store={store} paragraphSpacing='paragraphSpacing12' />
          </BodyWrapper>
          <Divider width='100%' margin='0px auto 6px auto' />
          <Like content={app.content} />
        </Main>
      </Wrapper>
    );
  }
}

Comment.propTypes = {
  app: PropTypes.object,
  thread: PropTypes.object,
  clientStore: PropTypes.object,
  first: PropTypes.bool,
  contentType: PropTypes.string,
  t: PropTypes.func,
};
